module.exports = "img/30.b2ebe5.webp";